var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-\u5F00\u653E\u5E73\u53F0\u5907\u4EFD 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-223.5, -56.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-35",
    transform: "translate(222, 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 1.2,
    y: 1.5,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st1",
    d: "M9.2,3c1.8,0,3.4,0.7,4.6,1.9c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0c-1-1-2.4-1.6-3.9-1.6 c-3,0-5.5,2.5-5.5,5.5S6.2,15,9.2,15c2.8,0,5-2,5.4-4.7c-0.3-0.2-0.4-0.5-0.4-0.8c0-0.6,0.4-1,1-1s1,0.4,1,1 c0,0.4-0.2,0.7-0.6,0.9c-0.4,3.2-3.2,5.6-6.4,5.6c-3.6,0-6.5-2.9-6.5-6.5S5.7,3,9.2,3z M9.4,6.4l1,0.2l-1.2,6l-1-0.2l0.1-0.5 L9.4,6.4z M6.9,7.7l0.7,0.7L6.5,9.5l1.1,1.1l-0.7,0.7L5.1,9.5L6.9,7.7z M11.6,7.7l1.8,1.8l-1.8,1.8l-0.7-0.7L12,9.5l-1.1-1.1 L11.6,7.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.66962ccad21f3cf9b0d90bb846247bf3.svg";
export { ForwardRef as ReactComponent };